// Общий зажим интервала опроса от сервера (как iOS HQ-1453): ошибка настройки сервера (1 с) не должна
// заставлять каждый открытый Mini App опрашивать раз в секунду.

export interface PollBounds { min: number; max: number }

const DEFAULT_BOUNDS: PollBounds = { min: 3, max: 600 };

/** interval_seconds сервера → мс для refetchInterval в пределах min…max секунд;
 *  null, нет ключа, 0, отрицательное, NaN, бесконечность — false (не опрашивать). */
export function clampPollMs(seconds: number | null | undefined, bounds: PollBounds = DEFAULT_BOUNDS): number | false {
  if (seconds == null || !Number.isFinite(seconds) || seconds <= 0) return false;
  return Math.min(bounds.max, Math.max(bounds.min, seconds)) * 1000;
}
